import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Camera, Lock } from "lucide-react";
import { proofLock } from "./CompletionProof";
import { API, authHeaders } from "../lib/supabase";

export const ProofSection = ({ dispatch: d }) => {
  const paths = d.completion_photo_urls || [];
  const [urls, setUrls] = useState([]);
  const [lightbox, setLightbox] = useState(null);
  useEffect(() => {
    if (!paths.length || !d.id || String(d.id).startsWith("outbox:")) return;
    authHeaders().then((h) => fetch(`${API}/jobs/${d.id}/proof`, { headers: h })).then((r) => (r.ok ? r.json() : { urls: [] })).then((j) => setUrls(j.urls || [])).catch(() => {});
  }, [d.id, paths.join("|")]); // eslint-disable-line react-hooks/exhaustive-deps
  const lock = proofLock(d);
  if (!paths.length && !d.completion_note && !lock.locked) return null;
  const fmt = (iso) => new Date(iso).toLocaleString(undefined, { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
  return (
    <section className="card mt-5 fade-up" data-testid="proof-section">
      <p className="eyebrow mb-1 flex items-center gap-1"><Camera size={12} /> Proof of completion</p>
      {d.completed_at && <p className="text-xs text-muted" data-testid="proof-completed-at">Completed {new Date(d.completed_at).toLocaleString()}</p>}
      {lock.locked && <p className="text-xs text-muted mt-1 flex items-center gap-1" data-testid="proof-lock-status"><Lock size={12} /> {paths.length || d.completion_note ? `Proof locked ${fmt(lock.at)} · read-only` : `No proof submitted — window closed ${fmt(lock.at)}`}</p>}
      {urls.length > 0 && <div className="photo-grid mt-3" data-testid="proof-section-thumbs">{urls.map((u, i) => <button type="button" key={u} className="photo-tile" onClick={() => setLightbox(u)} data-testid={`proof-section-photo-${i}`}><img src={u} alt="" loading="lazy" /></button>)}</div>}
      {d.completion_note && <p className="text-sm mt-3 result" data-testid="proof-section-note">“{d.completion_note}”</p>}
      {lightbox && createPortal(<div className="lightbox" onClick={() => setLightbox(null)} data-testid="proof-lightbox"><img src={lightbox} alt="" /></div>, document.body)}
    </section>
  );
};

export const ProofBadge = ({ dispatch: d }) => {
  const n = d.completion_photo_urls?.length || 0;
  if (!n) return null;
  return <span className="chip chip-green flex items-center gap-1" data-testid="proof-badge" title="Proof of completion"><Camera size={11} /> {n}</span>;
};
